import config from '../../template.config.js'

// Adds button to donation page donate/contribute2
const directDebitBtnTarget = document.querySelector('.tn-contribution-group2-page #tn-contribution-submit')

function addDirectDebitBtn (campaign, URL) {
    const form = `<form name="directDebitForm" method="post" action="${URL}">
        <input name="campaign" type="hidden" value="${campaign}">
    </form>`
    document.querySelector('.tn-contribution-group2-page').insertAdjacentHTML('afterend', form)

    const directDebitBtn = `<a id="directDebitButton" class="btn btn-default" href="#">Pay by Direct Debit</a>`
    directDebitBtnTarget.insertAdjacentHTML('afterend', directDebitBtn)
}

if (directDebitBtnTarget && config.directDebitCampaign && config.directDebitURL) {
    addDirectDebitBtn(config.directDebitCampaign, config.directDebitURL)

    // When contribution set to Select (no value) - hide button (same as rest of form)
    const typeSelection = document.getElementById('AddContribution_ContributionTypeId')
    if (typeSelection) {
        typeSelection.addEventListener('change', (e) => {
            const btn = document.getElementById('directDebitButton')
            if (e.currentTarget.value === '') {
                btn.style.display = 'none'
            }
            else {
                btn.style.display = ''
            }
        })
    }

    // on click of DD button, update value from main form and submit direct debit form
    const directDebitBtn = document.getElementById('directDebitButton')
    if (directDebitBtn) {
        directDebitBtn.addEventListener('click', () => {
            document.directDebitForm.submit()
        })
    }
}

// Update all remove buttons on the cart page to ensure the removal label is displayed on the frontend
const removeItemLabels = document.querySelectorAll('.tn-cart__btn-remove-label');
if (removeItemLabels) {
    removeItemLabels.forEach(button => {
        button.classList.remove('sr-only');
    });
}
